module.exports = __webpack_public_path__ + "img/law4-m@2.211177d2.jpg";